import * as React from "react";
const SvgArrowLeft = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m 5.5098687,12.029869 a 1.79,1.79 0 0 1 0.51,-1.28 L 16.399869,0.38986871 a 1.25,1.25 0 0 1 1.76,1.76999999 l -9.8600003,9.8700003 9.8600003,9.86 a 1.25,1.25 0 0 1 -1.76,1.77 l -10.3800003,-10.35 a 1.81,1.81 0 0 1 -0.51,-1.28 z" }));
export default SvgArrowLeft;
